import {
  getLocalStorageMeasureCardLastAcknowledgedVersion,
  setLocalStorageMeasureCardLastAcknowledgedVersion,
} from "api/dropsLocalStorage";
import { ALWAYS_MUTED_STATES } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/useMeasureCardMuteHistory";
import { MeasureOverviewDataContext } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewDataContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { Nullish } from "shared/utils/objectUtils";

export function useRecentlyUpdatedState(
  information: CombinedHistoryResponse,
  previousInformation: Nullish<CombinedHistoryResponse>,
) {
  const [lastAcknowledgedVersion, setLastAcknowledgedVersion] = useState(0);
  const { forceRefresh } = useContext(MeasureOverviewDataContext);

  const recentlyUpdated =
    information.version > lastAcknowledgedVersion &&
    !ALWAYS_MUTED_STATES.has(information.state);

  const acknowledgeLatestVersion = useCallback(() => {
    setLastAcknowledgedVersion(information.version);
    setLocalStorageMeasureCardLastAcknowledgedVersion(
      information.uuid,
      information.version,
    );
  }, [information]);

  useEffect(() => {
    const valueFromLocalStorage =
      getLocalStorageMeasureCardLastAcknowledgedVersion(information.uuid);

    if (valueFromLocalStorage === 0 && previousInformation === null) {
      // Information is the first version of a new event; automatically mark it seen
      setLocalStorageMeasureCardLastAcknowledgedVersion(information.uuid, 1);
      setLastAcknowledgedVersion(1);
      forceRefresh();
    } else {
      setLastAcknowledgedVersion(valueFromLocalStorage);
    }
  }, [information, previousInformation]);

  return { lastAcknowledgedVersion, acknowledgeLatestVersion, recentlyUpdated };
}
